<template>
    <div class="pagination" v-if="pagination.total_pages > 1">
        <span class="first" @click.stop="handle('first')" :class="{disabled:isFirst}">
            <font-awesome-icon icon="chevron-left"/>
            <font-awesome-icon icon="chevron-left"/>
        </span>
        <span class="prev" @click.stop="handle('prev')" :class="{disabled:isFirst}">
            <font-awesome-icon icon="chevron-left"/>
        </span>
        <span class="page-infos" @click.stop="togglePagesList">
            {{ $t('global.page') }} {{ pagination.current_page }} / {{ pagination.total_pages }} <font-awesome-icon icon="caret-up"/>
        </span>
        <span class="next" @click.stop="handle('next')" :class="{disabled:isLast}">
            <font-awesome-icon icon="chevron-right"/>
        </span>
        <span class="last" @click.stop="handle('last')" :class="{disabled:isLast}">
            <font-awesome-icon icon="chevron-right"/>
            <font-awesome-icon icon="chevron-right"/>
        </span>
        <div class="pages-list" :class="{show: showPageList}" v-on-clickaway="closePagesList">
            <ul class="scroll">
                <li :class="{active:n == pagination.current_pages}" v-for="n in pagination.total_pages"
                    @click.stop="go(n)">{{ $t('global.page') }} {{ n }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway'
    import {mapGetters} from 'vuex'

    export default {
        name: 'pagination',
        props: {
            store: {
                type: String,
                required: true
            }
        },
        mixins: [clickaway],
        computed: {

            pagination() {
                return this.$store.getters[this.store + '/pagination']
            },

            isFirst: function () {
                return this.pagination.current_page == 1;
            },
            isLast: function () {
                return this.pagination.current_page == this.pagination.total_pages;
            },

        },
        data: () => ({
            nbPages: 1,
            currentPage: 1,
            showPageList: false,
            firstTime: true
        }),
        methods: {
            handle: function (type) {
                var oldPage = this.pagination.current_page;

                switch (type) {
                    case 'first':
                        this.pagination.current_page = 1;
                        break;
                    case 'prev':
                        if (this.pagination.current_page > 1) {
                            this.pagination.current_page--;
                        }
                        break;
                    case 'next':
                        if (this.pagination.current_page < this.pagination.total_pages) {
                            this.pagination.current_page++;
                        }
                        break;
                    case 'last':
                        this.pagination.current_page = this.pagination.total_pages;
                        break;
                }

                if (oldPage != this.pagination.current_page) {
                    this.go();

                }
            },
            go: function (page) {

                if (page == null) {
                    if (page != this.pagination.current_page) {
                        page = this.pagination.current_page;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    this.pagination.current_page = page;
                }


                this.closePagesList();
                this.$emit('change', page);

            },
            togglePagesList: function () {
                this.showPageList = !this.showPageList;
                if (this.showPageList && this.firstTime) {
                    this.firstTime = false;
                }
            },
            closePagesList: function () {
                if (this.showPageList && !this.firstTime) {
                    this.showPageList = false;
                    this.firstTime = true;
                }
                else {
                    this.firstTime = false;
                }

            },
            update: function (obj) {
                this.nbPages = obj.total_pages;
                this.currentPage = obj.current_page;
            }
        },
        mounted() {

        },
        watch: {
            pagination(newValue) {
            }
        }
    }
</script>

<style lang="scss">
    .pagination {
        color: $main-white;
        display: inline-block;
        font-size: 1.3rem;
        font-weight: $semi-bold;
        height: $button-height;
        text-transform: uppercase;
        user-select: none;
        cursor: default;
        position: relative;

        span {
            cursor: pointer;
            line-height: $button-height;
            margin: 0 7px;
            transition-property: color;

            &.first, &.last {
                svg {
                    &:first-child {
                        margin-right: -7px;
                    }
                }
            }

            &:hover {
                color: $secondary-color;
            }

            &.disabled {
                color: rgba($main-white, 0.2);
            }

        }

        &.reverse {
            color: $main-black;

            span {
                &:hover {

                    color: $main-color;
                }

                &.disabled {
                    color: rgba($main-black, 0.2);
                }
            }
        }

        .pages-list {
            bottom: $button-height + 5px;
            background-color: $main-white;
            color: $main-black;
            font-size: 0.9rem;
            height: 114px;
            margin-left: 5px;
            opacity: 0;
            padding: 0;
            pointer-events: none;
            position: absolute;
            right: 70px;
            transform: scale(0, 0);
            transform-origin: calc(100% - 13px) calc(100% + 12px);
            transition-property: opacity, transform;
            width: 100px;
            z-index: 10000;
            //@include single-box-shadow(0px, 0px, 10px, 0px, rgba(0, 0, 0, 0.35));
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.35);

            &:before {
                border-color: #ffffff transparent transparent transparent;
                border-style: solid;
                border-width: 12.1px 7px 0 7px;
                content: '';
                height: 0;
                right: 5px;
                position: absolute;
                bottom: -12px;
                width: 0;

            }

            ul {
                list-style: none;
                margin: 0;
                padding: 0;

                li {
                    cursor: pointer;
                    font-size: 1.3rem;
                    font-weight: $semi-bold;
                    height: $button-height;
                    line-height: $button-height;
                    padding: 0 10px;
                    text-align: left;
                    transition-property: background-color, color;

                    &:hover {
                        background-color: $main-color;

                    }

                    &.active {
                        background-color: $main-black;
                        color: $main-color;
                    }
                }
            }

            &.show {
                opacity: 1;
                transform: scale(1, 1);
                pointer-events: auto;
            }
        }

    }

    .beepiz {
      .pagination {
        color: $main-black;
        display: inline-block;
        font-size: 1.3rem;
        font-weight: $semi-bold;
        height: $button-height;
        text-transform: uppercase;
        user-select: none;
        cursor: default;
        position: relative;

        span {
          cursor: pointer;
          line-height: $button-height;
          margin: 0 7px;
          transition-property: color;

          &.first, &.last {
            svg {
              &:first-child {
                margin-right: -7px;
              }
            }
          }

          &:hover {
            color: $secondary-color;
          }

          &.disabled {
            color: rgba($main-white, 0.2);
          }

        }

        &.reverse {
          color: $main-black;

          span {
            &:hover {

              color: $main-color;
            }

            &.disabled {
              color: rgba($main-black, 0.2);
            }
          }
        }

        .pages-list {
          bottom: $button-height + 5px;
          background-color: $main-white;
          color: $main-black;
          font-size: 0.9rem;
          height: 114px;
          margin-left: 5px;
          opacity: 0;
          padding: 0;
          pointer-events: none;
          position: absolute;
          right: 70px;
          transform: scale(0, 0);
          transform-origin: calc(100% - 13px) calc(100% + 12px);
          transition-property: opacity, transform;
          width: 100px;
          z-index: 10000;
          //@include single-box-shadow(0px, 0px, 10px, 0px, rgba(0, 0, 0, 0.35));
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.35);

          &:before {
            border-color: #ffffff transparent transparent transparent;
            border-style: solid;
            border-width: 12.1px 7px 0 7px;
            content: '';
            height: 0;
            right: 5px;
            position: absolute;
            bottom: -12px;
            width: 0;

          }

          ul {
            list-style: none;
            margin: 0;
            padding: 0;

            li {
              cursor: pointer;
              font-size: 1.3rem;
              font-weight: $semi-bold;
              height: $button-height;
              line-height: $button-height;
              padding: 0 10px;
              text-align: left;
              transition-property: background-color, color;

              &:hover {
                background-color: $main-color;

              }

              &.active {
                background-color: $main-black;
                color: $main-color;
              }
            }
          }

          &.show {
            opacity: 1;
            transform: scale(1, 1);
            pointer-events: auto;
          }
        }

      }
    }
</style>



// WEBPACK FOOTER //
// src/components/ui/Pagination.vue